import React from 'react';
import SEO from '../components/SEO';
import { seoData } from '../data/seo';
import { ExternalLink, ArrowRight } from 'lucide-react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { projects } from '../data/mock';
import { Link } from 'react-router-dom';

const Portfolio = () => {
  return (
    <div className="min-h-screen">
      <SEO {...seoData.portfolio} />
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-6">
            Our <span className="text-cyan-500">Portfolio</span>
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Showcasing our recent projects and success stories
          </p>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {projects.map((project, index) => (
              <Card
                key={project.id}
                className="overflow-hidden hover:shadow-xl transition-all duration-300 group rounded-lg"
              >
                {/* Project Image */}
                <div className="relative h-80 bg-gray-100 overflow-hidden">
                  <img
                    src={project.image}
                    alt={`${project.name} project screenshot`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute top-4 right-4">
                    <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-gray-900 text-xs font-medium rounded-full shadow-sm">
                      {project.category}
                    </span>
                  </div>
                </div>

                {/* Project Info */}
                <div className="p-6">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-3 group-hover:text-cyan-500 transition-colors">
                    {project.name}
                  </h2>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {project.description}
                  </p>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.tags.map((tag, idx) => (
                      <span
                        key={idx}
                        className="px-3 py-1 bg-cyan-100 text-cyan-700 text-xs font-medium rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  {/* Visit Link */}
                  <a
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-cyan-500 hover:text-cyan-600 font-medium group"
                  >
                    Visit Website
                    <ExternalLink className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Want to See Your Project Here?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Let's collaborate and create something amazing together!
          </p>
          <Link to="/contact">
            <Button className="bg-cyan-500 hover:bg-cyan-600 text-white rounded-full px-8 py-6 text-lg">
              Start Your Project
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
